import React, { Suspense, useEffect } from "react";
import PdfViewer from "../PdfViewer/PdfViewer";
import { useOffline } from "../../../offline/OfflineProvider";
import { ensureCached } from "../../../offline/fileCache";
import "./DocumentViewerOverlay.css";

const DocxViewer = React.lazy(() => import("../DocxViewer/DocxViewer"));
const XlsxViewer = React.lazy(() => import("../XlsxViewer/XlsxViewer"));
const XmlViewer = React.lazy(() => import("../XmlViewer/XmlViewer"));
const StpViewer = React.lazy(() => import("../StpViewer/StpViewer"));
const DwgViewer = React.lazy(() => import("../DwgViewer/DwgViewer"));

const DocumentViewerOverlay = ({ viewerState, onClose }) => {
  const { type, url, displayName, page, highlightBboxes, initialSheet, highlightText, scopeText, rowIndex, rowIds } = viewerState;
  const { isOnline, offlineEnabled, tenant, actions } = useOffline();

  // Cache-on-view: every document opened while online is stored for offline use
  // (the STP viewer needs the GLB preview, not the STP itself).
  useEffect(() => {
    if (!isOnline || !offlineEnabled || !tenant || !url) return;
    ensureCached({ tenant, url, kind: type === "stp" ? "glb" : "doc" })
      .then((status) => { if (status === "stored") actions.refreshFileStats(); })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, type, isOnline, offlineEnabled, tenant]);

  return (
    <div className="document-viewer-overlay">
      <Suspense fallback={<div className="viewer-loading">Viewer wird geladen...</div>}>
        {type === "pdf" && (
          <PdfViewer
            url={url}
            page={page}
            highlightBboxes={highlightBboxes}
            highlightText={highlightText}
            displayName={displayName}
            onClose={onClose}
          />
        )}
        {type === "docx" && (
          <DocxViewer url={url} displayName={displayName} onClose={onClose} />
        )}
        {(type === "xlsx" || type === "csv") && (
          <XlsxViewer
            url={url}
            displayName={displayName}
            onClose={onClose}
            initialSheet={initialSheet}
            highlightText={highlightText}
            scopeText={scopeText}
            rowIndex={rowIndex}
            rowIds={rowIds}
          />
        )}
        {type === "xml" && (
          <XmlViewer url={url} displayName={displayName} onClose={onClose} />
        )}
        {type === "stp" && (
          <StpViewer url={url} displayName={displayName} onClose={onClose} />
        )}
        {type === "dwg" && (
          <DwgViewer url={url} displayName={displayName} onClose={onClose} />
        )}
      </Suspense>
    </div>
  );
};

export default DocumentViewerOverlay;
